import { getRequest } from "../services/apiHelpers";

export const getInstitutions = async (query) => {
  try {
    const res = await getRequest({
      url: "/institutions",
      query: query,
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const getRoles = async (query) => {
  try {
    const res = await getRequest({
      url: "/roles",
      query: query,
    });
    return res;
  } catch (e) {
    throw e;
  }
};
